import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import GoogleMapReact from 'google-map-react';
import axios from 'axios';
//import * as ReactIonicons from 'react-ionicons';
import { capsFirstLetter } from '../helpers/util';
import CustomImage from './customImage.component';
//import { FaLock } from "react-icons/fa";
import * as ReactIonicons from 'react-icons/fa';

const DynIcon = ({ name }) => {  //Custom module for icon
    const IconComponent = ReactIonicons[capsFirstLetter(name)];  //RN and React takes icon name differently eg. Bicycle / bicycle
    if(!IconComponent) {  return <ReactIonicons.FaPlane />;  }
    return <IconComponent />;
}


export default function Gmap(){

    const loginState = useSelector(state => state.currentLogin);
    const [mapMarkers, setMapMarkers] = useState([]);
    const defaultProps = { //Have some default settings, just in case ...mapProps passed in is invalid
        center: {
            lat: 1.374434934884589,
            lng: 103.80348232204896
          },
        zoom: 11.3
    }

    useEffect(() => {
        const getMapMarkers = async () => {  //[To Update: 2021-06-27...] need to put these into Redux state instead of useState...
            await axios.get('/dataLogger/listDataLoggerLocationBrief', { headers: { Authorization: loginState.token} })
            .then(response => {
                setMapMarkers(response.data);
                console.log('*** Map Markers: ', response.data);
                //console.log('{config.API_URL}: ', config.API_URL);
            })
            .catch(error => {
                console.log('[Error] getAllLocations: ', error.message);
                if(error.response.status === 401){  //If Error 401 means user is not authorised
                    console.log('{*********} Error 401');
                    //Alert.alert('[Error] 401 Unauthorized');
                }
                if(error.response.status === 403){  //If Error 403 means user is not authorised or Token has expired, route back to login screen...
                    console.log('{*********} Error 403 found - Logging out User...');
                    //Alert.alert('Token has expired, please login again');
                    //navigation.navigate('Logout');
                    //signOut();
                }
            });
        }
        getMapMarkers();
    }, [loginState]);

    const Gmarkers = ({ name, dataLoggerId, markerImage, timestamp, markerIcon, markerColor, mainBattery, backupBattery, temperature, sensorTemperature, temp, chlorophyll, dissolvedOxygen, ph, salinity, saturation }) => 
    (   <div>
            <div className="gmarker" style={{ backgroundColor: markerColor }}>
                <div className="gmarkerinfo" style={{ borderColor: markerColor }}>
                    <CustomImage imageName={markerImage} /> <br />
                    <DynIcon name={markerIcon} />  <strong>{name} </strong> ({dataLoggerId})<br />
                    Timestamp: {timestamp} <br />
                    Main Battery: {mainBattery}v <br />
                    Backup Battery: {backupBattery}v <br />
                    Temperature: {temperature}°C <br />
                    Sensor Temperature: {sensorTemperature}°C <br />
                    Temp: {temp}°C <br />
                    Chlorophyll: {chlorophyll} <br />
                    Dissolved Oxygen: {dissolvedOxygen} <br />
                    PH: {ph} <br />
                    Salinity: {salinity} <br />
                    Saturation: {saturation} <br />
                </div>
            </div>
        </div>
    )


    return(  // Important! Always set the container height explicitly
        <div style={{ height: '90vh', width: '100%' }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyD2WyKRH1JzeXQGUsLn8Uq6sa3fDoDMixM' }}
                //bootstrapURLKeys={{ key: '234234234234' }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                //onGoogleApiLoaded={({ map, maps }) => renderMarkers( map, maps )} //render all markers on Gmap loaded
                yesIWantToUseGoogleMapApiInternals   
            >

                {mapMarkers.map((item, index) => { 
                    //console.log('>>> mapMarkers.map... ');
                    return(
                        <Gmarkers 
                            key={index}
                            lat={item.latitude}
                            lng={item.longitude}
                            name={item.name}
                            markerImage={item.marker_Image}
                            //siteImage={imgSrc}
                            dataLoggerId={item.data_Logger_Id}
                            timestamp={item.timestamp}
                            markerIcon={item.marker_Icon}
                            markerColor={item.marker_Color}
                            mainBattery={item.main_Battery}
                            backupBattery={item.backup_Battery}
                            temperature={item.temperature}
                            sensorTemperature={item.sensor_Temperature}
                            temp={item.temp}
                            chlorophyll={item.chlorophyll}
                            dissolvedOxygen={item.dissolved_Oxygen}
                            ph={item.ph}
                            salinity={item.salinity}
                            saturation={item.saturation}
                        />
                    );
                })}
            </GoogleMapReact>
        </div>
    );
}
